import React from "react";
import Authenticated from "@/Layouts/Authenticated";
import { useForm, usePage } from "@inertiajs/inertia-react";
import Label from "@/Components/Label";
import LoadingButton from "@/Components/LoadingButton";
import PageHeading from "@/Components/PageHeading";
import TextInput from "@/Components/TextInput";
import MultiSelectInput from "@/Components/MultiSelectInput";
import DateInput from "@/Components/DateInput";
import { Inertia } from "@inertiajs/inertia";

const Create = () => {
    const { groups } = usePage().props;

    const breadcrumb = [
        { name: "Dashboard", route: route("dashboard") },
        { name: "Student", route: route("students") },
        { name: "Create", route: null },
    ];

    const { data, setData, post, processing, errors, clearErrors, transform } =
        useForm({
            name: "",
            registration_no: "",
            identification_no: "",
            contact: "",
            groups: [],
            dob: null,
        });

    transform((data) => {
        return {
            ...data,
            groups: _.map(data.groups, "id"),
        };
    });

    function handleSubmit(e) {
        e.preventDefault();
        post(route("students.create"));
    }

    function handleCancel(e) {
        e.preventDefault();
        Inertia.visit(route("students"));
    }

    return (
        <div className="py-6">
            <PageHeading heading={"Add Student"} breadcrumb={breadcrumb} />
            <div className="mt-8">
                <div className="mx-auto max-w-lg px-4 py-10 pb-12 lg:pb-16">
                    <form onSubmit={handleSubmit}>
                        <div className="space-y-6">
                            <div>
                                <Label name={"name"} label={"Student Name"} />
                                <TextInput
                                    id={"name"}
                                    name={"name"}
                                    onChange={(e) =>
                                        setData("name", e.target.value)
                                    }
                                    errors={errors.name}
                                />
                            </div>
                            <div>
                                <Label
                                    name={"contact"}
                                    label={"Contact Number"}
                                />
                                <TextInput
                                    id={"contact"}
                                    name={"contact"}
                                    onChange={(e) =>
                                        setData("contact", e.target.value)
                                    }
                                    errors={errors.contact}
                                />
                            </div>
                            <div>
                                <Label
                                    name={"registration_no"}
                                    label={"Registration Number"}
                                />
                                <TextInput
                                    id={"registration_no"}
                                    name={"registration_no"}
                                    onChange={(e) =>
                                        setData(
                                            "registration_no",
                                            e.target.value
                                        )
                                    }
                                    errors={errors.registration_no}
                                />
                            </div>
                            <div>
                                <Label
                                    name={"identification_no"}
                                    label={"Identification Number"}
                                />
                                <TextInput
                                    id={"identification_no"}
                                    name={"identification_no"}
                                    onChange={(e) =>
                                        setData(
                                            "identification_no",
                                            e.target.value
                                        )
                                    }
                                    errors={errors.identification_no}
                                />
                            </div>
                            <div>
                                <Label name={"dob"} label={"Date of Birth"} />
                                <DateInput
                                    id={"dob"}
                                    name={"dob"}
                                    onChange={(e) =>
                                        setData("dob", e.target.value)
                                    }
                                    errors={errors.dob}
                                />
                            </div>
                            <div>
                                <MultiSelectInput
                                    items={groups}
                                    selected={data.groups}
                                    setSelected={(e) => setData("groups", e)}
                                    multiple={true}
                                />
                            </div>
                        </div>
                        <div className="pt-5">
                            <div className="flex justify-end space-x-1">
                                <LoadingButton
                                    type={"button"}
                                    onClick={handleCancel}
                                    loading={processing}
                                    className={"btn-secondary"}
                                >
                                    Cancel
                                </LoadingButton>
                                <LoadingButton
                                    type={"submit"}
                                    loading={processing}
                                    className={"btn-primary"}
                                >
                                    Save
                                </LoadingButton>
                            </div>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    );
};

Create.layout = (page) => <Authenticated title={"Student"} children={page} />;

export default Create;
